import cloneDeepWith from 'lodash/cloneDeepWith';
import { FRAGMENT_OWNER_KEY } from 'relay-runtime';

import { CLIENT_EDGE_TRAVERSAL_PATH_KEY } from './relayMetadataKeys.ts';

export function cloneRelayQueryResult<TData>(data: TData): TData {
	return cloneDeepWith(data, (value: unknown, key: number | string | undefined) => {
		// Relay fragment refs can contain operation descriptors and client-edge reader nodes.
		// Keep that internal metadata by reference while restoring Apollo-compatible mutable data.
		if (key === FRAGMENT_OWNER_KEY || key === CLIENT_EDGE_TRAVERSAL_PATH_KEY) {
			return value;
		}

		return undefined;
	});
}
